export default __webpack_public_path__ + "src/_images/chat-agent-image.jpg";